export default __webpack_public_path__ + "static/media/webinar-landing-hero.png";